import styled from 'styled-components';

import Tag from './Tag';

export default styled(Tag)`
  font-weight: 500;
  border-radius: 2px;
  margin-left: 12px;
  padding: 4px;
  font-size: 14px;
  background-color: var(--primary100);
  color: var(--primary900);
  white-space: nowrap;
`;
